import { render, staticRenderFns } from "./AddStartups.vue?vue&type=template&id=8e717474&scoped=true&"
import script from "./AddStartups.vue?vue&type=script&lang=js&"
export * from "./AddStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e717474",
  null
  
)

export default component.exports